import { TmpPackage } from '@/weappTmps/config.js'

// 第三方组件
import draggable from 'vuedraggable'

const staticTmps = {
  // test form cmp  
  // 第三方组件
  draggable
}
const TmpPackageKeyList = ['activeTmps', 'formTmps', 'managerTmps', 'comps']

function initTmps (tmps, type) {
  const nTmps = {}
  // console.log(`initTmps-tmps:${type}`,tmps)
  let name = '',
    paths = []
  for (let i in tmps) {
    paths = i.split('/')
    name = tmps[i].name || paths[0] + '_' + paths[1]
    nTmps[name] = tmps[i]
    // console.log(i,' ',name)
  }
  // console.log('nTmps',nTmps)
  return nTmps
}

// 组件配置类型
export const CMP_TYPES = ['formTmpsConfig', 'managerTmpsProps']

// 对应组件Props配置项
export const tmpConfigMap = {
  formTmpsConfig: TmpPackage.formTmpsConfig
}

// formTmps.SpInput/config
export function findTarget (source, type, key) {
  // console.log('source[type]',source[type])
  return source[type][`${key}/config`]
}

// 获取目标组件的 propsConfig
export function getTargetProps (type, key) {
  if (CMP_TYPES.indexOf(type) == -1) {
    console.error('CMP_TYPES not find type 请检查该组件类型是否正确')
    return false
  }
  const target = findTarget(tmpConfigMap, type, key)
  console.log('target', target)
  if (!target) {
    console.error(`getTarget not find ${type}-${key} ; 请检查是否正确注册该组件`)
    return false
  }
  return target.props
}

// 合并配置项用于tmpList生成
export function mergeConfig (staticData, packageData) {
  // console.log('mergeConfig-packageData', packageData)
  // console.log('staticData',staticData)
  let initDataMap = {}
  for (let i of staticData) {
    initDataMap[i.name] = i
  }
  for (let j in packageData) {
    initDataMap[packageData[j].name] = packageData[j]
  }
  return Object.values(initDataMap)
}

function getConfig (TmpPackage) {
  const configMap = {}
  for (let i in TmpPackage) {
    if (TmpPackage[i].config) {
      configMap[i] = TmpPackage[i].config
    }
  }
  console.log('configMap', configMap)
  return configMap
}

export const initConfigData = {
  // staticData: staticDataConfig.initData.formInitData,
  ...getConfig(TmpPackage)
}


export default {
  install (Vue) {
    let TmpPackageMap = {}
    for (let i in TmpPackage) {
      if (TmpPackageKeyList.indexOf(i) > -1) {
        TmpPackageMap = Object.assign(TmpPackageMap, initTmps(TmpPackage[i].tmps))
      }
    }
    console.log('TmpPackageList', TmpPackageMap)
    const mergeTmps = Object.assign(staticTmps, TmpPackageMap)
    console.log('mergeTmps', mergeTmps)
    for (let name in mergeTmps) {
      Vue.component(name, mergeTmps[name])
    }
    return mergeTmps
  },
}